import { Meta, Title } from '@angular/platform-browser';
import { SharingService } from '../../../services/sharing.service';
import { AppComponent } from '../../../app.component';
import {
    StoreDetailsResponse,
    Dealer,
    Storeimages,
    Visitingcard,
    SeoTags,
    StHour,
    EdHour,
    SellsProduct,
    Dealerreview,
    City,
} from '../../../models/dealer';
import {
    Component,
    OnInit,
    AfterViewInit,
    ViewChild,
    ElementRef,
    OnDestroy,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../services/api.service';
import { StoresResponse } from '../../../models/store';
import { FormBuilder, Validators } from '@angular/forms';
import { AdminBannerImages } from '../../../models/banner';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SurveyResponse } from '../../../models/survey';
import { CookieService } from 'ngx-cookie';
import { StarRatingComponent } from 'ng-starrating';
import { DatePipe } from '@angular/common';
import { AuthService } from 'src/app/services/auth.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { ApacService } from 'src/app/services/apac.service';
import { TranslateService } from '@ngx-translate/core';
import { HomeComponent } from 'src/app/home/home.component';
import { OffersComponent } from 'src/app/shared/shared-components/offers/offers.component';

declare var $: any;
declare var noUiSlider: any;

@Component({
    selector: 'app-store-site',
    templateUrl: './store-site.component.html',
    styleUrls: ['./store-site.component.css'],
    providers: [DatePipe],
})
export class StoreSiteComponent implements OnInit, AfterViewInit, OnDestroy {
    formattedAddress!: string;
    storeDetails!: any;
    dealer!: Dealer;
    storeImages?: Storeimages;
    visitingCard?: Visitingcard;
    storeBannerImages?: any;
    seoTags?: SeoTags;
    stHours?: StHour;
    edHours?: EdHour;
    products?: SellsProduct[];
    PC: boolean = false;
    SmartPhone: boolean = false;
    Tabs: boolean = false;
    Enterprise: boolean = false;
    leadResponse: any;
    storeId?: number;
    nameRequired: boolean = false;
    mobileRequired: boolean = false;
    emailRequired: boolean = false;
    pincodeRequired: boolean = false;
    mandaterequired: boolean = false;
    showBusinessHours: boolean = true;
    hasStoreImages: boolean = false;
    banners: AdminBannerImages[] = [
        {
            id: 3864,
            storeimage:
                '/data/store_images/outside 2021-09-23 at 12.22.47 PM - Copy -.jpeg',
        },
        {
            id: 3865,
            storeimage:
                '/data/store_images/WhatsApp Image 2021-09-23 at 12.21.18 PM.jpeg',
        },
    ];
    desktopBanner: any[] = [];

    @ViewChild('whatsLatest') whatsLatest?: OffersComponent;
    isDesktop: boolean = true;
    offersHeight: number = 267;
    assistanceHeight: number = 267;
    assistanceWidth: number = 550;
    checkedcolor = '#1B2B81';
    uncheckedcolor = '#e3e4f0';
    sizeRange = '22px';

    seoData: any;
    seoStoreId: any;
    slider: any;
    surveyRatingQuestions: City[] = [];
    checkIdsArr: number[] = [];
    fetchingQuestions = false;
    questions1!: string;
    questions2!: string;
    captcha!: string;
    surveyTimer: any;
    surveyModalRef: any;
    surveyDisplayed: boolean = false;
    @ViewChild('surveyModal') surveyModal?: ElementRef;
    @ViewChild('star1') star1?: StarRatingComponent;
    @ViewChild('star2') star2?: StarRatingComponent;
    @ViewChild('star3') star3?: StarRatingComponent;
    currentItem: number = 5;
    currentItem1: number = 11;
    ratingString: String[] = [];
    ratingString1: string[] = [];
    consent: boolean = false;
    mandate: boolean = false;
    con: string = '';
    lng: string = '';
    queryParams: any;

    constructor(
        private route: ActivatedRoute,
        public appComp: AppComponent,
        private apiService: ApiService,
        private fb: FormBuilder,
        private sharingService: SharingService,
        private meta: Meta,
        private titleMeta: Title,
        private modalService: NgbModal,
        private cookieService: CookieService,
        private datePipe: DatePipe,
        private router: Router,
        public apac: ApacService,
        public utility: UtilitiesService,
        private authService: AuthService,
        private title: Title,
        public translate: TranslateService,
        public home: HomeComponent
    ) {

        this.route.params.subscribe((params) => {
            this.formattedAddress = params.formattedAddress;
            this.con = params.con;
            this.lng = params.lng;
            this.translate.setDefaultLang(this.lng || 'en');
            this.translate.use(this.lng);

        });

        this.route.queryParams.subscribe(params => {
            this.queryParams = params
        });
        this.setupDeviceSpecificVariables();
    }
    setupDeviceSpecificVariables(): void {

        if ($(window).width() <= 767) {
            this.isDesktop = false;
            this.offersHeight = $(window).width() / (1284 / 896) - 12;
            const calH = $(window).width() / (1500 / 700) - 30;
            this.assistanceHeight = calH < 142 ? 142 : calH;
            this.assistanceWidth = (1500 / 700) * this.assistanceHeight;
        } else {
            this.isDesktop = true;
        }
    }

    getaCallForm = this.fb.group({
        name: ['', [Validators.required]],
        email: ['', [Validators.required,
        Validators.pattern(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ),]],
        mobile: ['', [Validators.required]],
        pincode: ['', [Validators.required]],
        mandate: ['', [Validators.required]],
    });

    get f() {
        return this.getaCallForm.controls;
    }
    lngs: any;
    ngOnInit(): void {
      
        if (
            this.appComp.latitude !== undefined &&
            this.appComp.longitude !== undefined
        ) {
            localStorage.setItem('lat', this.appComp.latitude);
            localStorage.setItem('lng', this.appComp.longitude);
        }

        this.appComp.localeId = this.lng + '-' + this.con;
        localStorage.setItem('localeId', this.lng + '-' + this.con);
        // localStorage.setItem('longitude', this.appComp.longitude);
        // localStorage.setItem('latitude', this.appComp.latitude);

        this.appComp.countryListShow = false;
        this.appComp.cityPopForUnSupported = false;
        this.appComp.isLoad = true;
        this.ratingString = [
            'Very Poor',
            'Poor',
            'Average',
            'Good',
            'Very Good',
        ];
        this.ratingString1 = [
            'Very Unlikely',
            'Unlikely',
            'Likely',
            'Very Likely',
        ];
        // this.apiService.getBannerImages(false).then(result => {
        //   this.banners = result.adminbannerimages;
        // });
        this.getAllcontent();
        this.apac
            .getformattedAddress(
                this.formattedAddress,
                this.appComp.tenantId,
                this.con,
                this.lng
            )
            .subscribe(
                (response) => {
                    this.storeDetails = response;
                    // this.reinitReviewsSlider();
                    // this.reinitFeaturedProducts();
                    this.getProducts(this.storeDetails.sellsProducts);
                    this.initSeoTags();
                    // this.reinitStorePhotoGalleryApac();
                    setTimeout(() => {
                        this.reinitReviewsSlider();
                        this.reinitFeaturedProducts();
                        this.reinitStorePhotoGalleryApac();
                        this.appComp.isLoad = false;
                        this.appComp.localeId = localStorage.getItem('localeId')
                            ? localStorage.getItem('localeId')
                            : this.appComp.localeId;
                        if (this.appComp.localeId.length > 2) {
                            let con = this.appComp.localeId
                                .split('-')[1]
                                .toLocaleLowerCase();
                            this.apac.countryNameSubject.next(con);
                        }
                        this.appComp.countryListShow = false;
                    }, 1000);
                },
                (err) => {
                    // this.router.navigateByUrl("/"+this.con+"/"+this.lng+"/not-found", { skipLocationChange: false });
                    this.router.navigate([this.con, this.lng, "store", this.formattedAddress, "not-found"])
                    this.appComp.isLoad = false;
                }
            );
        // this.apac.paymentMethods(this.formattedAddress, this.appComp.countryName, this.appComp.localeId.split("-")[0]).subscribe(val => {
        //   console.log("val => ",val)
        // })
        // this.utility.banners.subscribe(val =>{
        //   this.banners = val
        // })
    }

    ngOnDestroy() {
        clearInterval(this.surveyTimer);
    }
    tenantContent: any;
    getContent() {
        this.apac
            .getTenantContent('1', this.con, this.lng)
            .subscribe((data) => {
                // this.utility.banners.next(data.bannerimages.images);
                this.banners = data.bannerimages.images;
                this.desktopBanner = data.bannerimages.storeImages;
                this.appComp.tenantContent = data;
                this.tenantContent = data.faq;
            });
    }

    getAllcontent() {
        this.apac.getTenantContents().subscribe((value) => {
            this.apac.contents$.next(value);
            let data = value[this.con];
            this.banners = data.bannerimages.images;
            this.desktopBanner = data.bannerimages.storeImages;
            this.appComp.tenantContent = data;
            this.tenantContent = data.faq;
            this.utility.banners.next(data.bannerimages.images);
            this.appComp.popCities = data.cities_to_display_when_location_off;
            this.apac.supportedcountrylang().subscribe(conAndLang => {
                if (conAndLang.length > 0) {
                    if (Array.isArray(conAndLang)) {
                        this.appComp.languages = conAndLang.sort((a: object | any, b: object | any) => a.name.localeCompare(b.name));
                        this.appComp.countryName = this.con;
                        this.apac.languages$.next(this.appComp.languages);

                    }
                }
            })
        })
    }
    emailError = false;
    validMail() {
        let data = this.getaCallForm.value;
        if (!this.validateEmail(data.email)) {
            this.emailError = true;
        } else {
            this.emailError = false;
        }
    }
    ngAfterViewInit() { }



    reinitReviewsSlider() {
        if (this.storeDetails.reviews && this.storeDetails.reviews.length > 0) {
            let reviewPlaceHolder = `<div class="review-gallery clearfix" id="reviewGallery">%reviewsHolder%</div>`;
            let template = '';

            for (let review of this.storeDetails.reviews) {
                template =
                    template +
                    `<div class="col-3 card-bx mr-2">` +
                    `<h4>` +
                    review.display_Name +
                    `</h4>` +
                    `<span class="posted-txt">Posted on : ` +
                    this.datePipe.transform(review.crt_Dt, 'd/M/yyyy h:mm a') +
                    `</span>` +
                    `<div class="stars stars-gray">%reviewPlaceholder%</div>` +
                    `<p class="google-comment">` +
                    review.comment +
                    `</p>` +
                    `</div>`;

                let ratingTemplate = '';
                for (let i = 0; i < review.star_Rating; i++) {
                    ratingTemplate =
                        ratingTemplate +
                        `<div class="` +
                        (i + 1 <= review.star_Rating ? 'star gold' : 'star') +
                        `"></div>` +
                        `</ng-container>`;
                }
                template = template.replace(
                    '%reviewPlaceholder%',
                    ratingTemplate
                );
            }
            reviewPlaceHolder = reviewPlaceHolder.replace(
                '%reviewsHolder%',
                template
            );

            $('#reviewsPlaceHolder').append($(reviewPlaceHolder));
            const reviewsSlider = $('#reviewGallery').bxSlider({
                infiniteLoop: false,
                pager: false,
                controls: true,
                auto: false,
                pause: 10000,
                minSlides: 1,
                maxSlides: 4,
                // moveSlides: 1,
                slideWidth: 350,
                hideControlOnEnd: true,
            });
            if (reviewsSlider) {
                reviewsSlider?.redrawSlider();
            }
        }
    }

reinitFeaturedProducts() {
    let productsPlaceHolder = `<div class="view-offer-bx">
        <h2 class="section-title">` +
        this.translate.instant("store-listing.store-site.featured-products.title") +
        `</h2>
    
        <div class="offer-gallery" id="featuredProducts">
            %productsList%
        </div>
    </div>`;

    let template = '';
    for (let product of this.storeDetails.FeaturedProducts) {
        template +=
            `<div class="item">
                <div class="card-bx">
                    <div class="row clearfix">
                        <div class="col-12 pl-0">
                            <span class="product-img">
                                <img src="` +
            product.image +
            `" width="100%" height="auto"
                                    alt="" class="img-fluid">
                            </span>
                        </div>
                        <div class="col-12 text-center">
                            <span class="product-title">` +
            product.title +
            `</span>
                            <span class="product-desp">` +
            product.description +
            `</span>
                            <a href="https://www.google.com/" class="button-gradient d-none">Find Out</a>
                        </div>
                    </div>
                </div>
            </div>`;
    }

    productsPlaceHolder = productsPlaceHolder.replace('%productsList%', template);
    $('#featuredProductsPlaceHolder').append($(productsPlaceHolder));

    const containerWidth = $('#featuredProductsPlaceHolder').width();

    let visibleCards = 4; 
    if (containerWidth < 1200 && containerWidth >= 768) {
        visibleCards = 3; 
    } 
    else if (containerWidth < 768) {
        visibleCards = 1; 
    }
    $('#featuredProducts').bxSlider({
        infiniteLoop: false,
        controls: true,
        auto: false,
        pause: 10000,
        slideWidth: 350,
        minSlides: visibleCards,
        maxSlides: 10,
        moveSlides: 1,
    });

    setTimeout(() => {
        let maxHeight = 0;
        $('.card-bx').each(function (this: HTMLElement) {
            const thisHeight = $(this).outerHeight();
            if (thisHeight > maxHeight) {
                maxHeight = thisHeight;
            }
        });
        $('.card-bx').outerHeight(maxHeight);
    }, 300);
}

    getSelectedValue(workingHours: any) {
        let selectedval: any;
        workingHours.forEach(function (value: any) {
            if (value.selected) {
                selectedval = value;
                console.log(selectedval);
            }
        });
        return selectedval;
    }

    getProducts(sellsProducts: any) {
        sellsProducts.forEach((value: any) => {
            if (value.name == 'PC') {
                this.PC = true;
            } else if (value.name == 'SmartPhone') {
                this.SmartPhone = true;
            } else if (value.name == 'Tabs') {
                this.Tabs = true;
            } else if (value.name == 'Enterprise') {
                this.Enterprise = true;
            }
        });
    }


    getStoreImageIds(): number[] {
        let imgIds: number[] = [];
        if (
            this.storeDetails &&
            this.storeDetails.storeimages &&
            this.storeDetails.storeimages.storeimageids
        ) {
            const tmpImgIds =
                this.storeDetails.storeimages.storeimageids.split(',');
            for (let id of tmpImgIds) {
                imgIds.push(Number(id));
            }
        }
        return imgIds;
    }

    reinitStorePhotoGallery() {
        let template = '';
        let mobtemplate = '';

        let index = 0;
        for (let id of this.getStoreImageIds()) {
            this.hasStoreImages = true;
            template =
                template +
                `
            <div class="` +
                (index === 0 ? `col-12` : `col-6 mt-2`) +
                `" style="margin-bottom: 15px;">
                <a href="/partner/rest/service/image/store/` +
                id +
                `" data-fancybox="gallery1">
                    <img src="/partner/rest/service/image/store/` +
                id +
                `" width="100%" height="auto" alt=""
                        class="img-fluid">
                </a>
            </div>
        </div>`;

            index++;
        }

        mobtemplate =
            mobtemplate +
            `<div class="col-12">
            <img src = "/partner/rest/service/image/store/` +
            this.getStoreImageIds()[0] +
            `" width="100%" height="auto" alt="" class="img-fluid">
            </div>`;

        $('#storeImagesPlaceHolder2').append($(template));
        $('#seePhotos2').append(
            $(
                '<span data-fancybox-trigger="gallery1" style="cursor:pointer;">' +
                this.translate.instant(
                    'store-listing.store-site.store-images.see-photos'
                ) +
                '</span>'
            )
        );
        $('#seePhotos1').append(
            $(
                '<span data-fancybox-trigger="gallery1" style="cursor:pointer;">' +
                this.translate.instant(
                    'store-listing.store-site.store-images.see-photos'
                ) +
                '</a>'
            )
        );
        $('#storeImagesPlaceHolder1').append($(mobtemplate));

        $('[data-fancybox="gallery1"]').fancybox({
            // Options will go here
            buttons: ['close'],
        });
    }

    reinitStorePhotoGalleryApac() {
        let template = '';
        let mobtemplate = '';
        let index = 0;
        let i = 0;
        for (let img of this.storeDetails.partnerImages) {
            this.hasStoreImages = true;
            i++;
            // if (i < 5) {
            template =
                template +
                `
      <div class="` +
                (index === 0 ? `col-6` : `col-6 mt-2`) +
                (i >= 5 ? ` d-none` : '') +
                `" style="margin-bottom: 15px;">
          <a href="${img.location}" data-fancybox="gallery1">
              <img src="${img.location}" width="100%" height="auto" alt="${img.imageAltText}"
                  class="img-fluid">
          </a>
      </div>
  </div>`;
            // }
        }

        if (this.storeDetails.partnerImages.length < 4) {
            for (
                let j = 0;
                j < 4 - this.storeDetails.partnerImages.length;
                j++
            ) {
                template =
                    template +
                    `
      <div class="` +
                    (index === 0 ? `col-6` : `col-6 mt-2`) +
                    `" style="margin-bottom: 15px;">
              <img src="/assets/images/fallback.png" width="100%" height="auto" alt=""
                  class="img-fluid">
      </div>
  </div>`;
            }
        }

        mobtemplate =
            mobtemplate +
            `<div class="col-12">
      <img src = "` +
            this.storeDetails.partnerImages[0]?.location +
            `" width="100%" height="auto" alt="" class="img-fluid">
      </div>`;
        if (
            this.storeDetails.partnerImages &&
            this.storeDetails.partnerImages.length > 0
        ) {
            $('#storeImagesPlaceHolder2').append($(template));
            $('#seePhotos2').append(
                $(
                    '<span data-fancybox-trigger="gallery1" style="cursor:pointer;">' +
                    this.translate.instant(
                        'store-listing.store-site.store-images.see-photos'
                    ) +
                    ' (' +
                    this.storeDetails.partnerImages.length +
                    ')</span>'
                )
            );
            $('#storeImagesPlaceHolder1').append($(mobtemplate));
            $('#seePhotos1').append(
                $(
                    '<span data-fancybox-trigger="gallery1">' +
                    this.translate.instant(
                        'store-listing.store-site.store-images.see-photos'
                    ) +
                    '</a>'
                )
            );
        }

        $('[data-fancybox="gallery1"]').fancybox({
            // Options will go here
            buttons: ['close'],
        });
    }
    showStoreOffers(ev: any) {
        $(ev.target).toggleClass('open');
        $('.view-store-offer-bx').find('.cont-section').slideToggle();
    }
    popupmessage: any;
    image: any;
    submitDetails(contant: any) {
        let data = this.getaCallForm.value;
        if (!data.name) {
            this.nameRequired = true;
        } else {
            this.nameRequired = false;
        }


        // if (!data.email) {
        //     this.emailRequired = true;
        //     this.getaCallFormTouched();
        //     return;
        // } else {
        //     this.emailRequired = false;
        // }
        if (this.f.email.invalid) {
            this.emailRequired = true;
        } else {
            this.emailRequired = false;
        }
        if (!data.mobile) {
            this.mobileRequired = true;
        } else {
            this.mobileRequired = false;
        }
        if (!data.pincode) {
            this.pincodeRequired = true;
        } else {
            this.pincodeRequired = false;
        }
        if (this.mandate == false) {
            this.mandaterequired = true;
        } else {
            this.mandaterequired = false;
        }


        if (this.nameRequired == true || this.emailRequired == true || this.mobileRequired == true || this.pincodeRequired == true || (this.mandaterequired == true)) {
            this.getaCallFormTouched();
            return;
        }
        let leadDetails = {
            name: data.name,
            email: data.email,
            mobile: data.mobile,
            pincode: data.pincode,
            storeId: this.storeDetails.id,
            sourceName: 'Store Locator',
            consent: this.consent,
            mandate: data.mandate,
        };
        this.apac
            .submitGetacallForm(
                leadDetails,
                this.appComp.countryName,
                this.appComp.localeId.split('-')[0]
            )
            .subscribe(
                (response) => {
                    if (response !== undefined) {
                        this.leadResponse = response;
                        if (this.leadResponse.status == 'SUCCESS') {
                            this.popupmessage = 'Saved successfully';
                            this.image = 'unit-icon.png';
                            this.modalService
                                .open(contant, {
                                    ariaLabelledBy: 'modal-basic-title',
                                })
                                .result.then((result: any) => { });
                            setTimeout(() => {
                                $('.modal-dialog').attr(
                                    'id',
                                    'lead_save_alert_box'
                                );
                            }, 100);
                            this.getaCallForm.reset();
                            this.consent = false;
                            this.mandate = false;
                        } else {
                            this.popupmessage = this.leadResponse.status;
                            this.image = 'close-icon2.png';
                            this.modalService
                                .open(contant, {
                                    ariaLabelledBy: 'modal-basic-title',
                                })
                                .result.then((result: any) => { });
                            setTimeout(() => {
                                $('.modal-dialog').removeAttr('id');
                            }, 100);
                        }
                    }
                },
                (err: any) => {
                    console.log(err);
                }
            );
    }

    getaCallFormTouched() {
        this.getaCallForm.controls['name'].markAsTouched();
        this.getaCallForm.controls['email'].markAsTouched();
        this.getaCallForm.controls['mobile'].markAsTouched();
        this.getaCallForm.controls['pincode'].markAsTouched();
        this.getaCallForm.controls['mandate'].markAsTouched();
        this.getaCallForm.controls['name'].updateValueAndValidity();
        this.getaCallForm.controls['email'].updateValueAndValidity();
        this.getaCallForm.controls['mobile'].updateValueAndValidity();
        this.getaCallForm.controls['pincode'].updateValueAndValidity();
        this.getaCallForm.controls['mandate'].updateValueAndValidity();
    }

    validateEmail(email: any) {
        const re =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
    numberOnly(event: { which: any; keyCode: any }): boolean {
        const charCode = event.which ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        if (!/^[0-9]*$/.test(charCode)) {
            return false;
        }
        return true;
    }
    numberMobile(e: any) {
        e.target.value = e.target.value.replace(/[^\d]/g, '');
        return false;
    }

    share() {
        let text = '',
            title = '',
            url = '';
        text = '';
        if (this.storeDetails.phoneNumber) {
            text += 'Phone: ' + this.storeDetails.phoneNumber;
        }
        if (this.storeDetails.email) {
            text += ', \n ';
            text += 'Email: ' + this.storeDetails.email;
        }
        if (this.storeDetails.address) {
            text += ', \n ';
            text += 'Address: ' + this.storeDetails.address;
        }
        if (this.storeDetails.formattedAddress) {
            text += ', \n ';
            text += 'Website: ' + this.storeDetails.formattedAddress;
        }
        if (this.storeDetails.gmapLink) {
            text += ', \n ';
            text += 'Location map: ' + this.storeDetails.gmapLink;
        }

        if (this.storeDetails.titleTag == null) {
            this.title.setTitle(this.storeDetails.displayName);
        } else {
            this.title.setTitle(this.storeDetails.titleTag);
        }

        if (this.storeDetails.formattedAddress) {
            // url =this.con+'/' + this.lng +'/store/' + this.storeDetails.formattedAddress;
            url =
                url = `https://${location.hostname}/#/${this.con}/${this.lng}/store/${this.storeDetails.formattedAddress}`;
        }

        this.sharingService.share(text, title, url).then(() => {
            //do nothing
        });
    }

    initSeoTags() {
        if (this.storeDetails.titleTag == null) {
            this.title.setTitle(this.storeDetails.displayName);
        } else {
            this.title.setTitle(this.storeDetails.titleTag);
        }
        this.meta.updateTag({
            name: 'title',
            content:
                this.storeDetails.name + ' | ' + this.storeDetails.seoTitle,
        });
        this.meta.updateTag({
            property: 'og:title',
            content:
                this.storeDetails.name + ' | ' + this.storeDetails.seoTitle,
        });
        this.meta.updateTag({
            name: 'description',
            content: this.storeDetails.seoDescription,
        });
        this.meta.updateTag({
            property: 'og:description',
            content: this.storeDetails.seoDescription,
        });
        this.meta.updateTag({
            name: 'keywords',
            content: this.storeDetails.seoKeywords,
        });
        this.meta.updateTag({
            property: 'og:keywords',
            content: this.storeDetails.seoKeywords,
        });
    }

    initSeo() {
        if (
            this.storeDetails &&
            this.storeDetails.seoTags &&
            (this.storeDetails.seoTags.title ||
                this.storeDetails.seoTags.metaTitle)
        ) {
            let title = this.storeDetails.seoTags.title
                ? this.storeDetails.seoTags.title
                : this.storeDetails.seoTags.metaTitle;
            let metaTitle = this.storeDetails.seoTags.metaTitle
                ? this.storeDetails.seoTags.metaTitle
                : title;
            //this.meta.updateTag({ name: 'title', content: this.storeDetails.dealer.name + ' | ' + metaTitle });
            this.meta.updateTag({ name: 'title', content: '' + metaTitle });

            //this.titleMeta.setTitle(this.storeDetails.dealer.name + ' | ' + title);
            this.titleMeta.setTitle('' + title);

            this.meta.updateTag({
                property: 'og:title',
                content: '' + metaTitle,
            });
        }
        if (
            this.storeDetails &&
            this.storeDetails.seoTags &&
            this.storeDetails.seoTags.metaDescription
        ) {
            this.meta.updateTag({
                name: 'description',
                content: this.storeDetails.seoTags.metaDescription,
            });
            this.meta.updateTag({
                property: 'og:description',
                content: this.storeDetails.seoTags.metaDescription,
            });
        }
    }

    getAverageRating(): number {
        if (
            this.storeDetails &&
            this.storeDetails.reviews &&
            this.storeDetails.reviews.length > 0
        ) {
            return Number(this.storeDetails.avg_rating);
        }
        return 0;
    }

    initScriptTag() {
        this.seoStoreId = this.dealer.id;

        let script = document.createElement('script');
        script.type = 'application/ld+json';

        this.apiService
            .getStoreMarkupService(this.seoStoreId)
            .then((result) => {
                console.log('api data ' + result.name);
                this.seoData = result;
                script.text = `${JSON.stringify(this.seoData)}`;
                document.getElementsByTagName('head')[0].appendChild(script);
            });
    }

    rating3!: number;
    showSurveyNext(val: any, ev: any) {
        this.fetchingQuestions = false;
        if (val === 1) {
            this.setNextScreen(ev);
        }

        // if (val === 2) {

        //   this.setNextScreen(ev);
        // }

        if (val === 3) {
            if (this.checkIdsArr.length === 0) {
                alert('Please select at least one or more options.');
                return;
            }

            let dataLayer = (<any>window)['dataLayer'];
            dataLayer.push({
                event:
                    'pop-cx-form-stage-2-engagement-' +
                    this.appComp.surveyDisplayMode +
                    '-store-listing',
            });
            if ($('#range').length) {
                const range = document.querySelector('#range');
                var labels = {
                    0: '0',
                    1: '1',
                    2: '2',
                    3: '3',
                    4: '4',
                    5: '5',
                    6: '6',
                    7: '7',
                    8: '8',
                    9: '9',
                    10: '10',
                };
                this.slider = noUiSlider.create(range, {
                    start: 10,
                    connect: [true, false],
                    tooltips: {
                        to: function (value: any) {
                            return value > 10 ? '10+' : parseInt(value);
                        },
                    },
                    range: {
                        min: 0,
                        max: 10,
                    },
                    step: 1,
                    pips: {
                        mode: 'steps',
                        filter: function (value: any, type: {}) {
                            return type === 0 ? -1 : 1;
                        },
                        format: {
                            to: function (value: string) {
                                return value;
                            },
                        },
                    },
                });
            }

            /** third rating */
            if (this.starratingValue < 0) {
                alert('Please select a rating.');
            } else {
                let dataLayer = (<any>window)['dataLayer'];
                dataLayer.push({
                    event:
                        'pop-cx-form-submit-' +
                        this.appComp.surveyDisplayMode +
                        '-store-listing',
                });
                dataLayer.push({
                    event:
                        this.appComp.surveyDisplayMode +
                        '-store-listing' +
                        '-question-2-' +
                        this.starratingValue.toString(),
                });
                this.questions2 = this.starratingValue.toString();
                const payload = {
                    checkedIds: this.checkIdsArr.join(','),
                    questions1: this.questions1,
                    questions2: Number(this.questions2),
                    source_id: 150,
                    url: location.hostname + '/cx?sid=150',
                };
                this.apiService.submitSurvey(payload).then((resp) => {
                    if (resp.status === 'SUCCESS') {
                        this.setNextScreen(ev);
                    }
                });
            }
            // if (this.captcha === undefined) {
            //   alert('Please complete captcha before submitting your response.')
            // }
        }
    }

    setNextScreen(ev: any) {
        const elem = ev.currentTarget === null ? ev.target : ev.currentTarget;
        $(elem)
            .parents('.survey-screen')
            .css({ bottom: '100%', visibility: 'hidden' });
        $(elem)
            .parents('.survey-screen')
            .next('.survey-screen')
            .css({ bottom: 0, visibility: 'visible' });
    }

    closeSurveyScreen() {
        $('#surveyScreen').css({ right: '-100%', visibility: 'hidden' });
        setTimeout(() => {
            $('#surveyScreen .survey-screen').css({ bottom: '-100%' });
            $('.survey-screen-bx .survey-main-screen').css({ bottom: '0%' });
        }, 1000);

        if (this.slider) {
            this.slider.destroy();
        }

        this.surveyRatingQuestions = [];
        this.checkIdsArr = [];

        this.surveyModalRef.dismiss();
        clearInterval(this.surveyTimer);
        this.surveyDisplayed = false;

        if (this.star1) {
            this.star1.value = 0;
        }
        if (this.star2) {
            this.star2.value = 0;
        }
        if (this.star3) {
            this.star3.value = 0;
        }
        //noUiSlider = null;
    }

    resolved(captchaResponse: any) {
        this.captcha = captchaResponse;
    }

    captureResponse(resp: any) {
        const idx = this.checkIdsArr.indexOf(resp);
        if (idx === -1) {
            this.checkIdsArr.push(resp);
        } else {
            this.checkIdsArr.splice(idx, 1);
        }
    }

    dismissSurvey() {
        this.surveyModalRef.dismiss();
        clearInterval(this.surveyTimer);
        this.surveyDisplayed = false;
    }

    initSurveyFromPopup(val: any) {
        this.rated = val;
        let dataLayer = (<any>window)['dataLayer'];
        dataLayer.push({
            event:
                'pop-cx-form-stage-1-engagement-' +
                this.appComp.surveyDisplayMode +
                '-store',
        });
        dataLayer.push({
            event:
                this.appComp.surveyDisplayMode +
                '-store' +
                '-question-1-' +
                val,
        });

        this.initSurvey(val);
    }

    initSurvey(selection: any) {
        this.showSurvey();
        this.fetchQuestions(selection);
    }

    showSurvey() {
        $('#surveyScreen').css({ right: '0%', visibility: 'visible' });
        $('.survey-screen-bx .survey-second-screen').css({
            bottom: '0%',
            visibility: 'visible',
        });
        $('#radi').click();

        //this.modalService.dismissAll();
    }

    fetchQuestions(rating: string) {
        this.fetchingQuestions = true;

        this.apiService
            .getSurveyRating(this.appComp.surveySourceId, rating)
            .then((resp: SurveyResponse) => {
                console.log(resp);
                if (resp.status === 'SUCCESS') {
                    this.surveyRatingQuestions = resp.cities;
                    this.fetchingQuestions = false;
                }
            });

        this.questions1 = rating;
    }

    totalstar = 10;
    starratingValue: number = -1;

    onRate($event: {
        oldValue: number;
        newValue: number;
        starRating: StarRatingComponent;
    }) {
        // this.starratingValue = $event.newValue - 1;
        // let dataLayer = (<any>window)['dataLayer'];
        // dataLayer.push({ 'event': this.appComp.surveyDisplayMode + '-store' + '-question-2-' + this.starratingValue });
    }
    rated: any;
    onRate1($event: any) {
        this.rated = $event - 1;
        this.starratingValue = $event - 1;
        let dataLayer = (<any>window)['dataLayer'];
        dataLayer.push({
            event:
                this.appComp.surveyDisplayMode +
                '-store' +
                '-question-2-' +
                this.starratingValue,
        });
    }

    subStringvalue(value: any): string {
        if (value?.length > 0) {
            let start = value.lastIndexOf('/');
            let end = value.length - 1;
            value = value.substring(start + 1, end);
            return value;
        }
        return '';
    }
    isLoggedIn(): boolean {
        return this.storeDetails?.sellertype === 'Reseller';
    }
    goBack() {
        // if (this.appComp.localeId.length < 2) {
        //   this.appComp.localeId = localStorage.getItem('localeId');
        //   let con = this.appComp.localeId.split("-")[1].toLocaleLowerCase();
        //   let lng = this.appComp.localeId.split("-")[0].toLocaleLowerCase();
        //   this.router.navigate([con, lng]);
        // } else {
        //   let con = this.appComp.localeId.split("-")[1].toLocaleLowerCase();
        //   let lng = this.appComp.localeId.split("-")[0].toLocaleLowerCase();
        //   this.router.navigate([con, lng]);
        // }

        this.router.navigate([this.con, this.lng]);
    }

    hasPrivacyPolicy(json: any): boolean {
        json = this.appComp.tenantContent;
        if (!json.footer) {
            return false;
        }
        if (!json.footer.links) {
            return false;
        }
        for (let i = 0; i < json.footer.links.length; i++) {
            if (json.footer.links[i].name === "Privacy policy") {
                return true;
            }
        }
        return false;
    }

    getPrivacyPolicy(json: any): any {
        if (!json.footer) {
            return null;
        }
        if (!json.footer.links) {
            return null;
        }
        for (let i = 0; i < json.footer.links.length; i++) {
            if (json.footer.links[i].name === "Privacy policy") {
                return json.footer.links[i].url;
            }
        }
        return null;
    }
    
  

}
